<div class="layerItem">
  <appRectangle
    :item="completeItem"
    :index="index"
    :updateItem="updateItem"
    inline-template
  >
    <div
      :class="'rectangle-item '+ item.itemType"
      :style="getPos"
      @mousedown="mouseDown($event)"
      @mouseup="mouseUp($event)"
      @click="markAsActive($event)"
    >
      <component
        :active="isActive"
        :unit="unit"
        :is="rectangleComponent"
        :item="item"
        :index="index"
      ></component>
      <div v-show="!isActive" class="dragHandler"></div>
      <div
        v-if="item.rotatable"
        class="ui-rotatable-handle ui-draggable"
        @mousedown="mouseDown($event)"
        @mouseup="mouseUp($event)"
      ></div>
      <u v-if="isActive"></u>
    </div>
  </appRectangle>
  <appItemHelperline
    :item="completeItem"
    :index="index"
    :orientation="'vertical'"
  ></appItemHelperline>
  <appItemHelperline
    :item="completeItem"
    :index="index"
    :orientation="'horizontal'"
  ></appItemHelperline>
</div>
